import { UntypedFormGroup } from '@angular/forms';
import { DSM3SelectOption } from '@eredes/dsm3';
import { Subject } from 'rxjs';

export class SearchBarViewModel {
  constructor(
    public formGroup: UntypedFormGroup,
    public $states: Subject<DSM3SelectOption[]>,
    public $categories: Subject<DSM3SelectOption[]>,
    public $areas: Subject<DSM3SelectOption[]>
  ) {}
}
